// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Form from '../../ui/components/Forms/ChangePassword';
import { changePassword, closeModal } from '../../actions';

type Props = {
    auth: {
        isLoadingButton: boolean,
    },
    branding: Object,
    params: Object,
    changePassword: Function,
    closeModal: Function,
};

type State = {
    name: string,
    active: boolean,
};

export class ChangePassword extends Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            active: false,
        };
    }

    changePassword = (data: Object) => {
        if (this.props.auth.isLoadingButton) return;

        this.props.changePassword(
            data.password,
            data.newpassword,
            data.repassword
        );
    };

    handleFocus = e => {
        e.preventDefault();
        this.setState({
            name: e.target.name,
            active: !this.state.active,
        });
    };

    render() {
        const { auth, branding, params } = this.props;

        return (
            <Form
                auth={auth}
                onSubmit={this.changePassword}
                branding={branding}
                params={params}
                closeModal={this.props.closeModal}
                handleFocus={this.handleFocus}
                active={this.state.active}
                name={this.state.name}
                language={auth.language}
            />
        );
    }
}

const mapStateToProps = (state: Object) => {
    return {
        auth: state.auth,
        branding: state.branding,
        params: state.form.accountForm,
    };
};

export default connect(
    mapStateToProps,
    {
        changePassword,
        closeModal,
    }
)(ChangePassword);



// WEBPACK FOOTER //
// ./src/containers/Forms/ChangePassword.js